import React from "react";

function Slider({ url, title, subtitle, children }) {
    // Ensure the URL starts with a slash
    const formattedUrl = url.startsWith("/") ? url : `/${url}`;

    return (
        <div
            style={{ backgroundImage: `url(${formattedUrl})` }}
            className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-full tw-min-h-[50vh] tw-bg-no-repeat tw-bg-cover tw-bg-center"
        >
            <div className="tw-max-w-[85%] tw-text-center">
                <h1 className="tw-text-[#fff] text-shadow">{title}</h1>
                <h4 className="tw-text-[#fff] text-shadow">{subtitle}</h4>
            </div>
            {children}
        </div>
    );
}

export default Slider;
